import { GET, } from '@/components/api';
import { DICT_URL } from '../config';

/** 获取所有字典 */
export function dict_web_getAllDict_api() {
  return GET(`${DICT_URL}/getAllDict`);
}